
import React from 'react';
import { Lock } from 'lucide-react';

interface OrderSummaryProps {
    sellerName?: string;
    subtotal: number;
    shippingError?: string; // Placeholder for future shipping calc
    onCheckout: () => void;
    itemCount: number;
    className?: string;
    isSticky?: boolean;
}

const OrderSummary: React.FC<OrderSummaryProps> = ({
    sellerName,
    subtotal,
    onCheckout,
    itemCount,
    className = "",
    isSticky = false
}) => {
    // Basic formatting
    const formattedTotal = subtotal.toLocaleString('tr-TR');

    return (
        <div className={`bg-white dark:bg-gray-950 rounded-[2.5rem] p-8 shadow-sm border border-gray-100 dark:border-gray-800 ${isSticky ? 'sticky top-24' : ''} ${className}`}>
            <h3 className="font-black text-xl mb-8 text-gray-950 dark:text-white uppercase tracking-tighter italic">Sipariş Özeti</h3>

            <div className="space-y-4 mb-8">
                <div className="flex justify-between text-[11px] font-black uppercase tracking-widest text-gray-400 dark:text-gray-500">
                    <span>Ara Toplam ({itemCount} Ürün)</span>
                    <span className="text-gray-950 dark:text-white">₺{formattedTotal}</span>
                </div>

                {/* Placeholder for future detailed shipping */}
                <div className="flex justify-between items-center text-[11px] font-black uppercase tracking-widest text-gray-400 dark:text-gray-500">
                    <span>Kargo</span>
                    <span className="text-emerald-600 dark:text-emerald-400 text-[9px] bg-emerald-500/5 px-2.5 py-1 rounded-lg border border-emerald-500/10">Alıcı Ödemeli</span>
                </div>
            </div>

            <div className="border-t border-gray-50 dark:border-gray-900 pt-6 mb-10">
                <div className="flex justify-between items-end">
                    <div>
                        <span className="text-gray-400 dark:text-gray-500 text-[10px] font-black uppercase tracking-widest block mb-1">Genel Toplam</span>
                        {sellerName && <span className="text-[9px] font-black text-blue-500 uppercase tracking-widest flex items-center gap-1">
                            <span className="w-1 h-1 rounded-full bg-blue-500"></span>
                            {sellerName}
                        </span>}
                    </div>
                    <span className="text-4xl font-black text-gray-950 dark:text-white uppercase tracking-tighter italic">₺{formattedTotal}</span>
                </div>
            </div>

            <button
                onClick={onCheckout}
                className="w-full py-5 bg-gray-950 dark:bg-white text-white dark:text-gray-950 rounded-2xl font-black uppercase tracking-[0.2em] shadow-2xl hover:scale-105 active:scale-95 transition-all flex items-center justify-center gap-3 text-sm"
                aria-label={`Toplam ${formattedTotal} Türk Lirası tutarındaki sepeti onayla`}
            >
                <Lock size={18} strokeWidth={3} aria-hidden="true" />
                Sepeti Onayla
            </button>

            <div className="mt-6 flex items-center justify-center gap-2 text-[9px] font-black text-gray-400 dark:text-gray-500 uppercase tracking-[0.2em]">
                <Lock size={12} strokeWidth={3} />
                <span>256-bit SSL Güvenli Ödeme</span>
            </div>
        </div>
    );
};

export default OrderSummary;
